export function formatCpf(cpf) {
  cpf = cpf || '';
  if (cpf.length === 11) {
    return (
        cpf.substring(0, 3) + '.' +
        cpf.substring(3, 6) + '.' +
        cpf.substring(6, 9) + '-' +
        cpf.substring(9, 11));
  }
  return cpf;
}

export function parseCpf(cpf) {
  return cpf.replace(/\D+/g, '');
}

export function isValidCpf(cpf) {
  if (!cpf || cpf.length !== 11)
    return false;
  switch (cpf) {
    case '00000000000':
    case '11111111111':
    case '22222222222':
    case '33333333333':
    case '44444444444':
    case '55555555555':
    case '66666666666':
    case '77777777777':
    case '88888888888':
    case '99999999999':
      return false;
  }
  let sum1 = 0;
  let sum2 = 0;
  for (let i = 0; i < 9; i++) {
    const digit = parseInt(cpf[i]);
    sum1 += (10 - i) * digit;
    sum2 += (11 - i) * digit;
  }
  let dv1 = 11 - (sum1 % 11);
  if (dv1 >= 10) dv1 = 0;
  sum2 += 2 * dv1;
  let dv2 = 11 - (sum2 % 11);
  if (dv2 >= 10) dv2 = 0;
  return parseInt(cpf[9]) === dv1 && parseInt(cpf[10]) === dv2;
}


export const formatCPF = (value = "") => {
  const numeric = String(value).replace(/\D/g, "").slice(0, 11);
  if (!numeric) return "";
  return numeric
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2");
};


export const formatMaskedCPF = (value = "") => {
  const v = value.slice(0, 11).padEnd(11, "*").split("");

  return (
    `${v[0]}${v[1]}${v[2]}.${v[3]}${v[4]}${v[5]}.${v[6]}${v[7]}${v[8]}-${v[9]}${v[10]}`
  );
};


export const isValidCPF = (cpfDigits = "") => {
  if (!/^\d{11}$/.test(cpfDigits)) return false;
  if (/^(\d)\1{10}$/.test(cpfDigits)) return false;

  const numbers = cpfDigits.split("").map((d) => parseInt(d, 10));

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += numbers[i] * (10 - i);
  let remainder = 11 - (sum % 11);
  remainder = remainder > 9 ? 0 : remainder;
  if (remainder !== numbers[9]) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += numbers[i] * (11 - i);
  remainder = 11 - (sum % 11);
  remainder = remainder > 9 ? 0 : remainder;
  if (remainder !== numbers[10]) return false;

  return true;
};

/** Retorna um validador compatível com rules do Ant Design. Usa t() para traduções. */
export const validateCPFRule = (t) => async (_, value) => {
  const cpfDigits = value ? String(value).replace(/\D/g, "") : "";
  if (!cpfDigits) throw new Error(t("Por favor, insira o CPF"));
  if (cpfDigits.length !== 11) throw new Error(t("CPF deve ter 11 dígitos"));
  if (!isValidCPF(cpfDigits)) throw new Error(t("CPF inválido"));
  return true;
};
